function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { Box } from '@tapresearch/ui/components';
import React, { useMemo } from 'react';
import { FilterMultipleSelector } from '../../../common/Filter';
export function QualificationSelector(_param) {
    var qualification = _param.qualification, _param_isDisabled = _param.isDisabled, isDisabled = _param_isDisabled === void 0 ? false : _param_isDisabled, rest = _object_without_properties(_param, [
        "qualification",
        "isDisabled"
    ]);
    var options = useMemo(function() {
        return (qualification.attributes.custom_qualification_answers ? qualification.attributes.custom_qualification_answers : qualification.attributes.qualification_answers.sort(function(a, b) {
            return a.attributes.order_priority < b.attributes.order_priority ? -1 : 1;
        })).map(function(qAnswer) {
            return {
                value: qAnswer.attributes.pre_code.toString(),
                label: qAnswer.attributes.option_text
            };
        });
    }, [
        qualification.attributes.qualification_answers,
        qualification.attributes.custom_qualification_answers
    ]);
    return /*#__PURE__*/ React.createElement(Box, _object_spread_props(_object_spread({}, rest), {
        m: "0"
    }), /*#__PURE__*/ React.createElement(FilterMultipleSelector, {
        options: options,
        isDisabled: isDisabled,
        name: qualification.attributes.question_id.toString(),
        "data-testid": "qualification-".concat(qualification.id, "-filter"),
        m: "0"
    }));
}
